import { Space, Typography } from 'antd';
import { getI18n, useTranslation } from 'react-i18next';
import {
    ExportJobDataType,
    JobStatusTypeMap
} from '../../../containers/Pages/AdminPage/FiltersView/ExportFiltersView/ExportFiltersTable';
import { grispiNotification } from '../../../store/useNotificationStore';
import { pushTo } from '../../../utils/routeHelper';
import { tryCatch } from '../../MacroPage/MacroActionButton';

const { Link } = Typography;

const START_EXPORT = 'START_EXPORT';

type ExportFilterJobActionFunction = (jobData: ExportJobDataType, callback: () => Promise<void>) => Promise<void>;

const FilterExportJobActionButton: ExportFilterJobActionFunction = async (jobData, callback) => {
    grispiNotification(
        'loading',
        getI18n().t('exportFilter.downloadMessage.downloading', { ns: 'admin' }),
        START_EXPORT
    );
    tryCatch(async () => {
        pushTo(jobData?.result);
        grispiNotification(
            'success',
            getI18n().t('exportFilter.downloadMessage.downloaded', { ns: 'admin' }),
            START_EXPORT
        );
        await callback();
    }, START_EXPORT);
};
export default function FilterExportActionButton({
    jobData,
    callback
}: {
    jobData: ExportJobDataType;
    callback: () => Promise<void>;
}) {
    const { t } = useTranslation('admin');
    return (
        <>
            <Space size="middle">
                {(jobData?.status === JobStatusTypeMap.FINISHED ||
                    jobData?.status === JobStatusTypeMap.FINISHED_WITH_ERRORS) && (
                    <Link onClick={() => FilterExportJobActionButton(jobData, callback)}>
                        {t('exportFilter.downloadExport')}
                    </Link>
                )}
            </Space>
        </>
    );
}
